import { Box, ChevronIcon, Menu, Button } from "@mantine/core";

import strabismusTokenLinks from "./strabismusTokenLinks.json";

export const StrabismusSlideMenu = ({
  index,
  name,
}: {
  index?: number;
  name?: string;
}) => {
  const names = [
    "#1 Stratoneiros",
    "#2 Cryocirculus",
    "#3 Serpencarta",
    "#4 Spherovision",
    "#5 Spiracarta",
    "#6 Thermosharpia",
    "#7 Thermocirculus",
    "#8 Glaciacortex",
    "#9 Enigmoptix",
    "#10 Spectrolypse",
    "#11 Noctivelum",
    "#12 Nucleotex",
    "#13 Depthagon",
    "#14 Percepticon",
    "#15 Quadracanalis",
    "#16 Mesmeraether",
    "#17 Orthogonios",
    "#18 Spectravelum",
    "#19 Boaboreal",
    "#20 Stratospectrus",
  ];
  // Must include either name or index
  const finalName = name ? name : names[index!];
  const assetPrefix = finalName + "/" + finalName?.split(" ")[1];
  const links = strabismusTokenLinks as Record<string, { URL: string }>;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
      mt={16}
    >
      <Menu position="bottom">
        <Menu.Target>
          <Button color="secondary" size="xs" rightIcon={<ChevronIcon />}>
            Download assets
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "TWITTER.gif"]?.URL}
            target="_blank"
          >
            Twitter optimized GIF
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "WARPCAST.gif"]?.URL}
            target="_blank"
          >
            Farcaster optimized GIF
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "WEB.gif"]?.URL}
            target="_blank"
          >
            Web optimized GIF
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "TOKEN.gif"]?.URL}
            target="_blank"
          >
            Full size GIF
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "_SOCIAL.mp4"]?.URL}
            target="_blank"
          >
            Social share mp4
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "_TOKEN.mp4"]?.URL}
            target="_blank"
          >
            Full size mp4
          </Menu.Item>
          <Menu.Item
            component="a"
            href={links[assetPrefix + "STILL.jpg"]?.URL}
            target="_blank"
          >
            JPEG
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
};
